export default "assets/images/icons/mail-ebf8601c.svg";